module.exports = __webpack_public_path__ + "blank_sharing_drawingwp486e70a4903750fa358d7b57133cac80.png";